export default __webpack_public_path__ + "static/media/Rainforest.2b8619b7.png";